import React, { useState } from "react";
import AddToCart from "./AddToCart";
import SanityImage from "../SanityImage";
import SanityPortableText from "../SanityPortableText";
import clsx from "clsx";

const ProductEmbed = ({ input }) => {
  const { slug, texte, images } = input;
  // console.log(input);

  const [collapsed, setCollapsed] = useState(false);

  return (
    <section className='product' id={slug.current}>
      <div
        className={clsx("toggle")}
        role='button'
        tabIndex={0}
        aria-label='toggle image'
        aria-hidden='true'
        onClick={() => setCollapsed(!collapsed)}>
        <SanityImage input={{ image: images[0] }} />
      </div>
      {!collapsed && (
        <div className='p-md sm:px-md'>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              <div className='texte pr-md text-sm'>
                <SanityPortableText input={texte} />
              </div>
            </div>
            <div className='col-md-6 col-xs-12'>
              <AddToCart input={input} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductEmbed;
